import { render, staticRenderFns } from "./main-project.vue?vue&type=template&id=3cb14bd0&scoped=true&"
import script from "./main-project.vue?vue&type=script&lang=js&"
export * from "./main-project.vue?vue&type=script&lang=js&"
import style0 from "./main-project.vue?vue&type=style&index=0&id=3cb14bd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb14bd0",
  null
  
)

export default component.exports